import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, onBecomeObserved, onBecomeUnobserved, reaction, makeObservable } from "mobx";
import { now } from "mobx-utils";
export default function AutoRefreshingMixin(Base) {
  var _class;
  let AutoRefreshingMixin = (_class = class AutoRefreshingMixin extends Base {
    /** Return the interval in seconds to poll for updates. */

    /** Call hook for refreshing the item */

    constructor() {
      super(...arguments);
      _defineProperty(this, "autoRefreshDisposer", void 0);
      _defineProperty(this, "autorunRefreshEnableDisposer", void 0);
      makeObservable(this);
      // We should only poll when our map items have consumers
      onBecomeObserved(this, "mapItems", this.startAutoRefresh.bind(this));
      onBecomeUnobserved(this, "mapItems", this.stopAutoRefresh.bind(this));
    }
    startAutoRefresh() {
      if (!this.autorunRefreshEnableDisposer) {
        // Toggle autorefresh when `refreshEnabled` trait changes
        this.autorunRefreshEnableDisposer = reaction(() => this.refreshEnabled, () => {
          if (this.refreshEnabled) {
            this.startAutoRefresh();
          } else {
            this.stopAutoRefresh();
          }
        });
      }
      if (!this.autoRefreshDisposer && this.refreshEnabled) {
        this.autoRefreshDisposer = reaction(() => this._pollingTimer, () => {
          if (this.show) this.refreshData();
        });
      }
    }
    stopAutoRefresh() {
      if (this.autorunRefreshEnableDisposer) {
        this.autorunRefreshEnableDisposer();
        this.autorunRefreshEnableDisposer = undefined;
      }
      if (this.autoRefreshDisposer) {
        this.autoRefreshDisposer();
        this.autoRefreshDisposer = undefined;
      }
    }
    get _pollingTimer() {
      if (this.refreshInterval !== undefined) {
        return now(this.refreshInterval * 1000);
      } else {
        return undefined;
      }
    }
    get isPolling() {
      return this._pollingTimer !== undefined;
    }
    get nextScheduledUpdateTime() {
      if (this.refreshEnabled && this._pollingTimer !== undefined && this.refreshInterval !== undefined) {
        return new Date(this._pollingTimer + this.refreshInterval * 1000);
      } else {
        return undefined;
      }
    }
  }, _applyDecoratedDescriptor(_class.prototype, "_pollingTimer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_pollingTimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPolling", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPolling"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextScheduledUpdateTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nextScheduledUpdateTime"), _class.prototype), _class);
  return AutoRefreshingMixin;
}